/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import './index.scss'

const Experience = ({ experience }) => {
  return (
    <>
      <div className="timeline-item">
        <div className="timeline-item-content">
          <span className="tag">{experience.title}</span>
          <div className="timeline__company-time">
            <a href={experience.website} target="__blank">
              {' '}
              <small className="company">{experience.company.toUpperCase()}</small>
            </a>

            <div>
              <small>{experience.time}</small>
            </div>
          </div>
          <p>{experience.text}</p>
          {experience.link && (
            <a href={experience.link.url} target="_blank" rel="noopener noreferrer">
              {experience.link.text}
            </a>
          )}
          <div className="tech__used">
            {experience.tech.map(skill => (
              <small className="tech__skill" key={skill}>
                {skill}
              </small>
            ))}
          </div>
          <span className="circle" />
        </div>
      </div>
    </>
  )
}

export default Experience
